import Token from "../../login/vo/Token";

export function getStorageToken(storageKey): Token | null {
  const token = localStorage.getItem(storageKey);
  if (token !== null) {
    return JSON.parse(String(token));
  }
  return null;
}
